import { Box, MenuItem, Select, Typography } from "@mui/material";
import moment from "moment";
import { useState, useMemo } from "react";

import CategorySalesReport from "./CategorySalesReport";
import PaymentMethodReport from "./PaymentMethodReport";
import "./Reports.css";
import SalesSummaryReport from "./SalesSummaryReport";

function Reports(props) {
  const [filter, setFilter] = useState("last7");
  const [reportFilter, setReportFilter] = useState("sales");

  const getDateRange = useMemo(() => {
    const today = moment();
    let startDate, endDate;

    switch (filter) {
      case "today":
        startDate = today.clone();
        endDate = today.clone();
        break;
      case "yesterday":
        startDate = today.clone().subtract(1, "day");
        endDate = today.clone().subtract(1, "day");
        break;
      case "last7":
        startDate = today.clone().subtract(7, "days");
        endDate = today.clone();
        break;
      case "last28":
        startDate = today.clone().subtract(28, "days");
        endDate = today.clone();
        break;
      case "last30":
        startDate = today.clone().subtract(30, "days");
        endDate = today.clone();
        break;
      case "thisWeek":
        startDate = today.clone().startOf("week");
        endDate = today.clone();
        break;
      case "lastWeek":
        startDate = today.clone().subtract(1, "week").startOf("week");
        endDate = today.clone().subtract(1, "week").endOf("week");
        break;
      default:
        startDate = today.clone();
        endDate = today.clone();
    }

    return { startDate, endDate };
  }, [filter]);

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const dateRangeText = `${getDateRange.startDate.format("MMM DD")} – ${getDateRange.endDate.format("MMM DD, YYYY")}`;

  return (
    <Box p={4}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Select
          value={reportFilter}
          onChange={(e) => setReportFilter(e.target.value)}
          size="small"
          sx={{ minWidth: 160 }}
        >
          <MenuItem value="sales">Sales Summary</MenuItem>
          <MenuItem value="category">Category Sales</MenuItem>
          <MenuItem value="payment">Payment Method</MenuItem>
        </Select>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gap={1}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 600,
              px: 2,
              py: 1,
              borderRadius: 1,
              fontSize: "14px",
            }}
          >
            {dateRangeText}
          </Typography>

          <Select size="small" value={filter} onChange={handleFilterChange}>
            <MenuItem value="today">Today</MenuItem>
            <MenuItem value="yesterday">Yesterday</MenuItem>
            <MenuItem value="last7">Last 7 days</MenuItem>
            <MenuItem value="last28">Last 28 days</MenuItem>
            <MenuItem value="last30">Last 30 days</MenuItem>
            <MenuItem value="thisWeek">This week (Sun - Today)</MenuItem>
            <MenuItem value="lastWeek">Last week (Sun - Sat)</MenuItem>
            {/* <MenuItem value="last90">Last 90 days</MenuItem>
            <MenuItem value="last12m">Last 12 months</MenuItem>
            <MenuItem value="thisYear">This year (Jan - Today)</MenuItem>
            <MenuItem value="lastYear">Last calender year</MenuItem>
            <MenuItem value="custom">Custom</MenuItem> */}
          </Select>
        </Box>
      </Box>

      <Box>
        {reportFilter === "sales" && (
          <SalesSummaryReport
            startDate={getDateRange.startDate.format("YYYY-MM-DD")}
            endDate={getDateRange.endDate.format("YYYY-MM-DD")}
          />
        )}
      </Box>
      <Box>
        {reportFilter === "category" && (
          <CategorySalesReport
            startDate={getDateRange.startDate.format("YYYY-MM-DD")}
            endDate={getDateRange.endDate.format("YYYY-MM-DD")}
          />
        )}
      </Box>
      <Box>
        {reportFilter === "payment" && (
          <PaymentMethodReport
            startDate={getDateRange.startDate.format("YYYY-MM-DD")}
            endDate={getDateRange.endDate.format("YYYY-MM-DD")}
          />
        )}
      </Box>
    </Box>
  );
}

export default Reports;
